import { render, staticRenderFns } from "./Consulting.vue?vue&type=template&id=69f97202&scoped=true&"
import script from "./Consulting.vue?vue&type=script&lang=js&"
export * from "./Consulting.vue?vue&type=script&lang=js&"
import style0 from "./Consulting.vue?vue&type=style&index=0&id=69f97202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f97202",
  null
  
)

export default component.exports